import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import { AuthInfo, clearAuthData, isLoggedIn } from "stores/slices/auth";
import { changeLayout } from "stores/slices/layout";

import { STORAGE_KEYS, WORKSPACE_USER_TYPE } from "../constants/appConstant";
import store from "../stores/configStore";
import StorageHelper from "../utils/storeHelper";

const AuthLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(isLoggedIn);
  const verifyToken = StorageHelper.getCookie(STORAGE_KEYS.verifyToken);

  const authInfo = useSelector(AuthInfo);
  useEffect(() => {
    if (isAuthenticated && authInfo?.id) {
      if (authInfo.workspaceRole === WORKSPACE_USER_TYPE.OPERATOR) {
        dispatch(changeLayout("OPERATOR"));
        if (authInfo.workspaceRole) {
          navigate("/inbox/messages");
        } else {
          navigate("/profile");
        }
      } else {
        dispatch(changeLayout("ADMIN"));
        navigate("/admin/dashboard");
      }
    }
    if (!isAuthenticated && verifyToken) {
      StorageHelper.removeCookie(STORAGE_KEYS.verifyToken);
      StorageHelper.removeCookie(STORAGE_KEYS.token);
      StorageHelper.removeLocalItem(STORAGE_KEYS.user);
      store.dispatch(clearAuthData());
      navigate("/auth/sign-in");
    }
  }, [isAuthenticated]);

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
export default AuthLayout;
